addEventListener("DOMContentLoaded", () => {
  const modifiedImages = new Set(); // Keep track of already modified images

  const checkGiftBoxIframe = () => {
    const gbIframe = document.querySelector('#giftbox-root iframe');

    if (gbIframe && gbIframe.contentWindow && gbIframe.contentWindow.document) {
      const imgs = Array.from(gbIframe.contentWindow.document.body.querySelectorAll('img'));
      
      imgs.forEach(img => {
        if (img.src.includes('_small') && !modifiedImages.has(img)) {
          const newSrc = img.src.replace(/_small/g, '');
          modifiedImages.add(img); // Mark this image as modified

          // Preload the new image
          const preloader = new Image();
          preloader.onload = () => {
            img.src = newSrc; // Update src only after the new image has loaded
          };
          preloader.src = newSrc;
        }
      });
    }

    // Handle mobile version
    const gbMobileIframe = document.querySelector('.react-modal-sheet-content iframe');
    if (gbMobileIframe) {
      const mobileImgs = Array.from(gbMobileIframe.contentWindow.document.body.querySelectorAll('img'));
      mobileImgs.forEach(img => {
        if (img.src.includes('_small') && !modifiedImages.has(img)) {
          const newSrc = img.src.replace(/_small/g, '');
          modifiedImages.add(img); // Mark this image as modified

          // Preload the new image
          const preloader = new Image();
          preloader.onload = () => {
            img.src = newSrc; // Update src only after the new image has loaded
          };
          preloader.src = newSrc;
        }
      });
    }
  };

  // Continuously check for the presence of the Gift Box iframe and images within it
  setInterval(checkGiftBoxIframe, 100);
});